export default {
    namespaced: true,

    state() {
        return {
            user: null,
        }
    },

    mutations: {
        setUser(state, payload) {
            state.user = payload;
        }
    },

    actions: {
        async register(context, payload, auto_login=true) {
            const user = (await this.$api.post("auth/registration/", {...payload, auto_login}))?.data.user;

            context.commit("setUser", user);

            return user.id;
        },
    },

    getters: {
        getUser(state) {
            return state.user;
        }
    }
}